module.exports = __webpack_public_path__ + "img/avatar-user-female.db0b9806.svg";